import { bucketsForUserAndDayQueryOptions } from "@/api/buckets/bucketsForUserAndDayQueryOptions";
import { BucketEndWarningDialog } from "@/components/buckets/BucketEndWarningDialog";
import { useBucketEndWarning } from "@/hooks/useBucketEndWarning";
import { useKeycloak } from "@/hooks/useKeycloak";
import { useQuery } from "@tanstack/react-query";

import { dateToBerlinIsoDay } from "@workspace/datetime";
import { bucketStatus } from "@workspace/schemas/drizzle/buckets";

/** Mounted once at the root so the warning fires on any page while the user's bucket runs. */
export function BucketEndWarning() {
  const { keycloak, authenticated } = useKeycloak();
  const userId = keycloak.subject;
  const { data: buckets } = useQuery(
    bucketsForUserAndDayQueryOptions(userId ?? "", dateToBerlinIsoDay(new Date()), {
      enabled: authenticated && userId !== undefined,
      // Same-tab bucket mutations already invalidate ["buckets"]. The interval picks up edits from other tabs.
      refetchInterval: 60_000,
    }),
  );
  const bucket = buckets?.find((b) => b.status === bucketStatus.IN_PROGRESS);
  return <BucketEndWarningDialog {...useBucketEndWarning(bucket)} />;
}
